import { HoneyOfferType, OfferDetailType } from '../types/StorePageType'
import {
  MIN_AVG_SAVED,
  MAX_LAST_USED_HOURS,
  MAX_EXPIRY_HOURS
} from '../lib/client-constants'
import { FormatMessage } from '../lib/useWorldReady'
import isTruthy from './is-truthy'

const HOUR_IN_MILLISECONDS = 3600000

const getLastSaved = (offer: HoneyOfferType) => {
  let discount = 0
  if (offer.appliedLastDiscount) {
    // Transforme number: 1234 -> 12.34
    const changeNumberToDecimal = (number: number) =>
      parseFloat(number.toString().replace(/(\d{2})(\d*)/, '$1.$2')).toFixed(2)

    discount = parseFloat(
      offer.appliedLastDiscount.toString().length > 2
        ? changeNumberToDecimal(offer.appliedLastDiscount)
        : offer.appliedLastDiscount.toFixed(2).toString()
    )
  }
  return discount >= MIN_AVG_SAVED ? discount : 0
}

const getLastused = (offer: HoneyOfferType) => {
  const lastUsed =
    offer.appliedLastTs &&
    Math.round(
      new Date().getTime() / HOUR_IN_MILLISECONDS -
        offer.appliedLastTs / HOUR_IN_MILLISECONDS
    )

  return lastUsed && lastUsed > 0 && lastUsed <= MAX_LAST_USED_HOURS
    ? lastUsed
    : 0
}

const getExipiry = (offer: HoneyOfferType) => {
  const expiry =
    offer.expires &&
    Math.round(
      offer.expires / HOUR_IN_MILLISECONDS -
        new Date().getTime() / HOUR_IN_MILLISECONDS
    )
  return expiry && expiry > 0 && expiry <= MAX_EXPIRY_HOURS ? expiry : 0
}

export const getOfferData = (
  offer: HoneyOfferType,
  storeUrl: string,
  fptiSessionId: string,
  storeId: string
) => {
  const description = offer.description || ''
  const couponCode = offer.type === 'COUPON' ? offer.code : null

  const offerData: OfferDetailType = {
    description,
    couponCode,
    storeUrl,
    offerId: offer.dealId,
    lastUsed: getLastused(offer),
    lastSaved: getLastSaved(offer),
    expiresIn: getExipiry(offer),
    uses: offer.appliedCount,
    meta: offer.meta,
    type: offer.type,
    exclusive: offer.exclusive,
    offerUrl: offer.url,
    fptiSessionId,
    storeId
  }

  return offerData
}

export const getOfferMetaText = (
  offerData: OfferDetailType,
  formatMessage: FormatMessage
) => {
  switch (true) {
    case isTruthy(offerData.meta.percentOff):
      return formatMessage('main.storePage.offerDetails.percentOffMeta', {
        percentOff: offerData.meta.percentOff
      })
    case isTruthy(offerData.meta.dollarOff):
      return formatMessage('main.storePage.offerDetails.dollarOffMeta', {
        dollarOff: offerData.meta.dollarOff
      })
    case isTruthy(offerData.meta.freeShipping):
      return formatMessage('main.storePage.offerDetails.freeShippingMeta')
    case isTruthy(offerData.meta.freeDelivery):
      return formatMessage('main.storePage.offerDetails.freeDeliveryMeta')
    case isTruthy(offerData.meta.freeDelivery):
      return formatMessage('main.storePage.offerDetails.freeDeliveryMeta')
    case isTruthy(offerData.meta.freeGift):
      return formatMessage('main.storePage.offerDetails.freeGiftMeta')
    case isTruthy(offerData.meta.bogo):
      return formatMessage('main.storePage.offerDetails.buyOneGetOneMeta')
    case offerData.type === 'COUPON':
      return formatMessage('main.storePage.offerDetails.codeMeta')
    default:
      return formatMessage('main.storePage.offerDetails.saleMeta')
  }
}
